import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';

/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';
import { InboxRoutingModule } from './inbox-routing.module'
import { WorkbenchComponent } from './workbench/workbench.component';

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services'
import { SharedComponentsModule } from 'app/ViewModules/shared-components';
import { BaseframeworkModule } from 'app/BaseFramework';
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';
//import { TaskListFilter } from 'app/BaseFramework/shared/custom-pipes/taskListFilter';
import { DndListModule } from 'ngx-drag-and-drop-lists';

const _components = [WorkbenchComponent]


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    InboxRoutingModule,
    SharedComponentsModule,
    BaseframeworkModule,
    CustomPipesModule,
    DndListModule
  ],
  declarations: [..._components],
  exports: [..._components]
})
export class InboxUWModule {
  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService: MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }
}
